import React from 'react';
import PropTypes from 'prop-types';
import Env from 'root/lib/Env';
import styled
  from 'styled-components';
import { useSelector } from 'react-redux';
import { getIsQuestInDemoMode } from 'root/activities/hub/selectors/workshopSelectors';

const AutoCompleteButton = ({ onClick, label }) => {
  const isDemo = useSelector(getIsQuestInDemoMode);
  if (!Env.isDevEnv || isDemo) {
    return null;
  }
  return (
    <StyledButton onClick={onClick} className="auto-complete-button">
      {label}
    </StyledButton>
  );
};
AutoCompleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

AutoCompleteButton.defaultProps = {
  label: 'Auto Complete',
};

export default AutoCompleteButton;

const StyledButton = styled.button`
  position: absolute;
  top: 35px;
  right: 50%;
  transform: translate(50%, 0);
`;
